/** Long enough to carry a name and the gist, short enough to stay on screen. */
const MAX_LENGTH = 140;

export interface NotificationToastInput {
  title?: string;
  body?: string;
  merged?: boolean;
}

/**
 * The single line a person reads when a notification arrives anywhere in the
 * product.
 *
 * Returns null when there is nothing to say. An older backend — or a
 * notification created before the stream carried a title — sends only an id,
 * and an empty toast is worse than no toast: it interrupts without informing.
 * The caller stays silent in that case while the query invalidation still
 * updates the bell, so nothing is lost.
 *
 * A `merged` arrival only updated a grouped notification — five agents
 * finishing one lead fold into a single entry — so announcing every fold
 * would bring back the five interruptions the grouping removed.
 */
export function toToastMessage({ title, body, merged }: NotificationToastInput): string | null {
  if (merged) return null;

  const heading = title?.trim();
  if (!heading) return null;

  const detail = body?.trim();
  const full = detail ? `${heading} — ${detail}` : heading;

  if (full.length <= MAX_LENGTH) return full;

  return `${full.slice(0, MAX_LENGTH - 1).trimEnd()}…`;
}
